import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import Layout from '@/layout'

const constantRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/views/search/index.vue'),
      },
      {
        path: 'enrolment',
        name: 'Enrolment',
        component: () => import('@/views/enrolment/index.vue')
      },
      {
        path: 'parentingclass',
        name: 'ParentingClass',
        component: () => import('@/views/parentingclass/index.vue')
      },
      {
        path: 'controlcenter',
        name: 'ControlCenter',
        component: () => import('@/views/controlcenter/index.vue'),
        meta: { isSearch: true }
      },
      {
        path: 'view',
        name: 'View',
        component: () => import('@/views/controlcenter/view.vue'),
        meta: { isSearch: true }
      },
    ]
  },
]

// const asyncRoutes = [
//   {
//     path: '/enrolment',
//     name: 'Enrolment',
//     component: () => import('@/views/enrolment/index.vue')
//   },
//   {
//     path: '/parentingclass',
//     name: 'ParentingClass',
//     component: () => import('@/views/parentingclass/index.vue')
//   },
//   {
//     path: '/controlcenter',
//     name: 'ControlCenter',
//     component: () => import('@/views/controlcenter/index.vue')
//   }
// ]

const createRouter = () => new VueRouter({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router
